<template>
    <div>
        <ModalGlobal id="ModalRememberClose" v-if="$store.state.componentes.modalSessionExpired"
            @close-modal="$store.dispatch('setModalSessionExpired', false);">
            <template #dialogHeadImg>
                <img class="absolute h-22 -top-12 left-0 right-0 m-auto pointer-events-none"
                    :src="$S3AssetUrl('suf/home/photo-pass-logo.png')" alt="Grupo Xcaret | Foto"
                    title="Grupo Xcaret | Foto" />
            </template>

            <template #dialogHeading>{{ $t('Forms.imp') }}</template>

            <template #dialogDescription>
                <span class="block text-justify" v-html="$t('Modals.session_expired')"></span>
            </template>
        </ModalGlobal>
    </div>
</template>

<script>
export default {
    props: [],
    mixins: [],
    components: {},
    data: () => ({}),
    computed: {},
    watch: {},
    methods: {},
    created() {},
    mounted() {},
};
</script>

